module.exports = __webpack_public_path__ + "static/media/checkbox-unselected.8942159f.svg";